import React, { useEffect, useState } from "react";
import { Star, Sparkles } from "lucide-react";
import api from "../lib/api";

const Testimonials = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/testimonials")
      .then((r) => {
        setItems(r.data || []);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  if (loading || !items.length) return null;

  const allItems = [...items, ...items, ...items]; // Duplicate for seamless looping

  return (
    <section className="py-20 bg-foreground text-background overflow-hidden" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        <span className="text-xs uppercase tracking-[0.2em] opacity-70">Real stories</span>
        <h2 className="font-serif-display text-4xl sm:text-5xl mt-2 max-w-2xl">What our happy customers say</h2>
      </div>
      
      <div className="relative">
        {/* Gradient overlays for smooth fading edges */}
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-foreground to-transparent z-10 hidden sm:block" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-foreground to-transparent z-10 hidden sm:block" />

        <div className="flex gap-6 animate-marquee w-max">
          {allItems.map((t, i) => (
            <div key={i} className="w-[350px] sm:w-[400px] shrink-0 bg-white/5 border border-white/10 rounded-[2rem] p-8 backdrop-blur-sm hover:bg-white/10 transition-colors">
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating || 5 }).map((_, k) => <Star key={k} className="w-4 h-4 fill-primary text-primary" />)}
              </div>
              <p className="text-base leading-relaxed mb-8 opacity-90 italic">"{t.text}"</p>
              <div className="flex items-center gap-4 mt-auto">
                <div className="w-12 h-12 rounded-2xl bg-primary/20 flex items-center justify-center text-primary font-bold text-xl uppercase">
                  {t.name?.charAt(0) || "C"}
                </div>
                <div>
                  <div className="text-base font-bold text-white">{t.name}</div>
                  <div className="text-xs opacity-60 flex items-center gap-1">
                    <Sparkles className="w-3 h-3" /> Verified Client • {t.city || "NCR"}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
